import "../../styles/studio/visualization/descriptionInput.css";

const MAX_DESCRIPTION_LENGTH = 300;

const DescriptionInput = ({ description, setDescription, isLoading }) => {
  return (
    <div className="description-input">
      <label className="description-label">
        Description <span className="required">*</span>
      </label>

      <textarea
        placeholder="Briefly describe what this visualization is about"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        maxLength={MAX_DESCRIPTION_LENGTH}
        rows={4}
        className="description-field"
        disabled={isLoading}
      />

      <div className="description-meta">
        <span className="hint">Shown in listings and previews</span>
        <span className="count">
          {description.length}/{MAX_DESCRIPTION_LENGTH}
        </span>
      </div>
    </div>
  );
};

export default DescriptionInput;
